<template>
  <div class="fill-an-address">
    <navbar title="填写收货地址" />
    <div class="fill-address-tips">
      <span>!</span>
      <span>
        因为本次订单商品包含多家供应商，地址信息需要分别提交
        为了能让您顺利完成购物，请按要求填写，非常感谢。
      </span>
    </div>
    <div class="address-warapper">
      <div class="address-title van-hairline--bottom">
        本地址将提供给
        <em>{{ platformBrand }}</em>
      </div>
      <div class="form">
        <vm-select
          :disabled="isDisabledProvince"
          :loading="isDisabledProvince"
          @change="chooseProvince"
          class="address-select"
          filterable
          placeholder="省级地区"
          v-model="province"
        >
          <vm-option
            :key="item.code"
            :label="item.name"
            :value="item.code"
            v-for="item in provinceLists"
          ></vm-option>
        </vm-select>
        <vm-select
          :disabled="isDisabledCity"
          :loading="isDisabledCity"
          @change="chooseCity"
          class="address-select"
          filterable
          placeholder="市级地区"
          v-model="city"
        >
          <vm-option
            :key="item.code"
            :label="item.name"
            :value="item.code"
            v-for="item in cityLists"
          ></vm-option>
        </vm-select>
        <vm-select
          :disabled="isDisabledDistrict"
          :loading="isDisabledDistrict"
          @change="chooseDistrict"
          class="address-select"
          filterable
          placeholder="区级地区"
          v-model="district"
        >
          <vm-option
            :key="item.code"
            :label="item.show_name"
            :value="item.code"
            v-for="item in districtLists"
          ></vm-option>
        </vm-select>
        <vm-select
          :disabled="isDisabledTown"
          :loading="isDisabledTown"
          @change="chooseTown"
          class="address-select"
          filterable
          placeholder="街道地区"
          v-model="town"
          v-show="townLists.length"
        >
          <vm-option
            :key="item.code"
            :label="item.name"
            :value="item.code"
            v-for="item in townLists"
          ></vm-option>
        </vm-select>
        <!-- 请输入地址 -->
        <field
          :border="false"
          :maxlength="60"
          :rows="4"
          placeholder="请输入具体的地址、街道、楼牌号等"
          type="textarea"
          v-model="detailsAddress"
        />
        <field :border="false" placeholder="收货人" v-model="username" />
        <field
          :border="false"
          :maxlength="11"
          placeholder="手机号码"
          type="tel"
          v-model="userPhone"
        />
        <button @click="submitAddress" class="save">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Field } from 'vant'
import { VmSelect, VmOption } from 'vue-multiple-select'
import Navbar from '../components/NavBar'
let flag = false
export default {
  name: 'fillAnAddress',
  components: {
    Navbar,
    Field,
    VmSelect,
    VmOption
  },
  props: {
    platformName: {
      type: String
    },
    platformType: {
      type: String
    },
    platformBrand: {
      type: String
    }
  },
  data () {
    return {
      provinceLists: [],
      cityLists: [],
      districtLists: [],
      townLists: [],
      province: '',
      provinceName: '',
      city: '',
      cityName: '',
      district: '',
      districtName: '',
      town: '',
      townName: '',
      detailsAddress: '',
      username: '',
      userPhone: '',
      name: ''
    }
  },
  computed: {

    isDisabledProvince () {
      if (!this.provinceLists.length) {
        return true
      } else {
        return false
      }
    },
    isDisabledCity () {
      if (!this.cityLists.length) {
        return true
      } else {
        return false
      }
    },
    isDisabledDistrict () {
      if (!this.districtLists.length) {
        return true
      } else {
        return false
      }
    },
    isDisabledTown () {
      if (!this.townLists.length) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.getAddressdetails({ name: 'province', code: 0 })
  },
  methods: {
    ...mapActions('order', ['uploadUserAddress']),
    ...mapActions('shopingCart', [
      'updateUserAddressHandler',
      'editUserAddressHandler'
    ]),

    /**
     * 地址联动
     */
    async getAddressdetails ({ name, code }) {
      const res = await this.$axios.get(`api/address/yk/${this.platformType}/${code}`)
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          this[`${name}Lists`] = data
        }
      }
    },

    /**
     * 重置省份
     */
    async chooseProvince (e) {
      if (!e) {
        return false
      }
      this.provinceName = this.provinceLists.find(v => v.code === e).name
      await this.getAddressdetails({ name: 'city', code: e })
      this.city = ''
      this.districtLists = []
      this.district = ''
      this.townLists = []
      this.town = ''
    },

    /**
     * 市选择
     */
    async chooseCity (e) {
      if (!e) {
        return false
      }
      this.cityName = this.cityLists.find(v => v.code === e).name
      await this.getAddressdetails({ name: 'district', code: e })
      this.district = ''
      this.townLists = []
      this.town = ''
    },

    /**
     * 区选择
     */
    async chooseDistrict (e) {
      if (!e) {
        return false
      }
      this.districtName = this.districtLists.find(v => v.code === e).name
      await this.getAddressdetails({ name: 'town', code: e })
      this.town = ''
    },
    chooseTown (e) {
      if (!e) {
        return false
      }
      this.townName = this.townLists.find(v => v.code === e).name
    },

    /**
     * 保存地址
     */
    async submitAddress () {
      if (this.province === '') {
        this.$toast('请选择省级地区')
        return
      } else if (this.city === '') {
        this.$toast('请选择市级地区')
        return
      } else if (this.district === '') {
        this.$toast('请选择区级地区')
        return
      } else if (this.town === '' && this.townLists.length) {
        this.$toast('请选择街道地区')
        return
      } else if (this.detailsAddress === '') {
        this.$toast('请填写详细地址')
        return
      } else if (this.username === '') {
        this.$toast('请输入收货人姓名')
        return
      } else if (this.userPhone === '') {
        this.$toast('请输入收货人手机号')
        return
      } else if (!/^[1][3,4,5,6,7,8,9]\d{9}$/.test(this.userPhone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (flag) {
        return false
      }
      flag = true
      this.$toast.loading('正在保存,请稍候...')
      const userAddress = {
        platform: this.platformType,
        province_name: this.provinceName,
        province_code: this.province,
        city_name: this.cityName,
        city_code: this.city,
        district_name: this.districtName,
        district_code: this.district,
        town_name: this.townName ? this.townName : '0',
        town_code: this.town ? this.town : '0',
        address_detail: this.detailsAddress,
        mobile: this.userPhone,
        name: this.username
      }
      const status = await this.updateAddress(userAddress)
      if (status) {
        flag = false
        this.$router.back()
      }
    },

    /**
     * 更新地址信息
     */
    async updateAddress (address) {
      const res = await this.$axios.post('api/address/add', { ...address })
      if (res.status === 200) {
        const { code, msg } = res.data
        flag = false
        if (code === 0) {
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    }
  }
}
</script>
<style lang="less">
// vue-multiple-select 样式
.form {
  .address-select {
    width: 100%;
    margin-bottom: 0.25rem;
    .vm-input {
      width: 100%;
      input::-webkit-input-placeholder {
        color: #969696;
      }
      .vm-input__icon {
        color: #ccc;
      }
    }
    .vm-select-input__inner {
      width: 100%;
      border-color: #ccc;
    }
  }
  //  vant input样式
  .van-cell--borderless {
    border: 0.02rem solid #ccc;
    border-radius: 0.1rem;
    margin-bottom: 0.25rem;
  }
}
</style>
<style lang="less" scoped>
.fill-an-address {
  background-color: #f8f8f8;
  font-size: @fz24;
  color: @base;
  .fill-address-tips {
    margin: 0.24rem 0.2rem;
    padding: 0.2rem;
    background-color: #fffae4;
    border: 0.02rem solid #ffe1af;
    font-size: @fz24;
    color: #e67e22;
    border-radius: 0.12rem;
    box-sizing: border-box;
    .flex-between;
    span:nth-child(1) {
      width: 0.3rem;
      height: 0.3rem;
      border: 0.02rem solid #ffe1af;
      border-radius: 50%;
      .flex-center;
    }
    span:nth-child(2) {
      width: 6.24rem;
    }
  }
  .address-warapper {
    width: 7.1rem;
    padding-bottom: 0.25rem;
    margin: 0.3rem auto 0;
    background-color: #fff;
    border-radius: 0.12rem;
    .address-title {
      padding: 0.24rem 0;
      padding-left: 0.8rem;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.32rem;
        height: 0.33rem;
        background: url("../assets/img/ad-icon.png") center no-repeat;
        background-size: 100%;
      }
      em {
        font-weight: bold;
      }
    }
    .save {
      width: 6.7rem;
      height: 0.88rem;
      margin-top: 0.25rem;
      font-size: @fz26;
      color: #fff;
      background-color: #0076ff;
      border-radius: 30px;
    }
  }
  .form {
    padding: 0.22rem;
  }
}
</style>
